import { baseApi } from 'services/api';
import { API_TAG_TYPES, API_VERSION } from 'constants/common';
import {
  FsmCustomerPortalSessionResponse,
  FsmSubscriptionConfirmPayload,
  FsmSubscriptionConfirmResponse,
  FsmSubscriptionSetupResponse,
  FsmSubscriptionUpdatePayload,
  FsmSubscriptionUpdatePaymentMethodPayload,
  FsmSubscriptionUpdatePaymentMethodResponse,
  FsmSubscriptionUpdateResponse
} from './fsmSubscription.model';
import { TeamIdPayload } from 'containers/home/home.model';

const fsmIntegrationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSetupIntent: builder.mutation<FsmSubscriptionSetupResponse, TeamIdPayload>({
      query: ({ teamId }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/fsm-subscription/setup`,
        method: 'POST'
      }),
      extraOptions: {
        failure: 'Failed to setup FSM subscription',
        showToast: true
      }
    }),
    confirmSubscription: builder.mutation<FsmSubscriptionConfirmResponse, FsmSubscriptionConfirmPayload>({
      query: ({ teamId, body }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/fsm-subscription/confirm`,
        method: 'POST',
        body
      }),
      extraOptions: {
        failure: 'Failed to confirm FSM subscription',
        showToast: true
      },
      invalidatesTags: [API_TAG_TYPES.MERCHANT_CUSTOMIZATIONS]
    }),
    updatePaymentMethod: builder.mutation<
      FsmSubscriptionUpdatePaymentMethodResponse,
      FsmSubscriptionUpdatePaymentMethodPayload
    >({
      query: ({ teamId, paymentMethodId }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/fsm-subscription/payment-method`,
        method: 'PATCH',
        body: { paymentMethodId }
      }),
      invalidatesTags: [API_TAG_TYPES.MERCHANT_CUSTOMIZATIONS],
      extraOptions: {
        failure: 'Failed to update payment method',
        showToast: true
      }
    }),
    updateSubscription: builder.mutation<FsmSubscriptionUpdateResponse, FsmSubscriptionUpdatePayload>({
      query: ({ teamId, cancel, resume }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/fsm-subscription/update`,
        method: 'PATCH',
        body: { cancel, resume }
      }),
      invalidatesTags: [API_TAG_TYPES.MERCHANT_CUSTOMIZATIONS],
      extraOptions: {
        failure: 'Failed to update subscription',
        showToast: true
      }
    }),
    resumeSubscription: builder.mutation<FsmSubscriptionUpdateResponse, TeamIdPayload>({
      query: ({ teamId }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/fsm-subscription/resume`,
        method: 'POST'
      }),
      invalidatesTags: [API_TAG_TYPES.MERCHANT_CUSTOMIZATIONS],
      extraOptions: {
        failure: 'Failed to resume FSM subscription',
        showToast: true
      }
    }),
    createCustomerPortalSession: builder.mutation<FsmCustomerPortalSessionResponse, TeamIdPayload>({
      query: ({ teamId }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/fsm-subscription/customer-portal-session`,
        method: 'POST'
      }),
      extraOptions: {
        failure: 'Failed to create customer portal session',
        showToast: true
      }
    })
  })
});

export const {
  useGetSetupIntentMutation,
  useConfirmSubscriptionMutation,
  useUpdatePaymentMethodMutation,
  useUpdateSubscriptionMutation,
  useResumeSubscriptionMutation,
  useCreateCustomerPortalSessionMutation
} = fsmIntegrationApi;
